import { createAsyncThunk } from '@reduxjs/toolkit';
import { removeCookie } from '../../controllers/DynamicCookies';
import NEWAPI from '../../API/newIndex';

// done
export const getCurrencyRate = createAsyncThunk(
  'default/getCurrencyRate',
  async (_, { rejectWithValue }) => {
    try {
      const res = await NEWAPI({
        url: '/admin/commondata/currencyrate',
        method: 'GET',
      });

      const currencyRate = res?.data?.currency_rate ?? [];
      localStorage.setItem('currencyrate', JSON.stringify(currencyRate));
      return currencyRate;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

// done
export const getClientData = createAsyncThunk(
  'default/getClientData',
  async (_, { rejectWithValue }) => {
    try {
      const businessName = localStorage.getItem('business_name');
      if (!businessName) return null;

      const res = await NEWAPI({
        url: '/admin/client/getClient',
        method: 'GET',
      });

      const clientData = res?.data?.data ?? null;
      const staticUrl = res?.data?.staticUrl ?? null;

      if (staticUrl) {
        localStorage.setItem('staticUrl', staticUrl);
      }

      return { clientData, staticUrl };
    } catch (err) {
      if (err?.response?.status === 881) {
        removeCookie('token');
        localStorage.removeItem('business_name');
      }
      return rejectWithValue(err);
    }
  },
);